<template>
  <md-tab id="tab-market-area" md-label="Market Area" md-icon="map">
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0"
      >
        <sidebar-search tab="market_area" title="Favorite Market Areas" />
      </div>
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0"
      >
        <div>
          <PulseLoader :loading="!loaded" :class="{hide: loaded}"></PulseLoader>
          <!-- <pulse-loader :color="'blue'" :loading="!loaded"></pulse-loader> -->
        </div>
        <div
          :key="componentKey"
          v-if="loaded && searchMarketAreas == null && !searchLoadingMarketArea"
        >
          <div
            @click="$store.commit('F_SET_MARKET_AREA', 'US [9999]')"
            class="US-9999 available"
          >
            ALL US
          </div>
          <div
            v-for="(stateId, state) in markets"
            :key="state"
            @click="chooseMarket($event)"
            :class="
              `${removeSpaces(state)} [${stateId}] ${
                availableMarkets.includes(state) ? 'available' : 'unavailable'
              } unclicked correct-padding `
            "
          >
            {{ state }}
          </div>
        </div>
        <div>
          <!-- <pulse-loader
            :color="'blue'"
            :loading="searchLoadingMarketArea && searchMarketAreas == null"
          ></pulse-loader> -->
        </div>
        <div v-if="searchMarketAreas != null">
          <div
            v-if="
              searchMarketAreas[0].states.length == 0 &&
                searchMarketAreas[0].metros.length == 0 &&
                searchMarketAreas[0].counties.length == 0 &&
                searchMarketAreas[0].zips.length == 0
            "
            class="available"
          >
            No results! Please try different keyword.
          </div>
          <div v-if="searchMarketAreas[0].states.length != 0" class="available">
            States:
            <div
              v-for="(searchMarket, searchIndex) in searchMarketAreas[0].states"
              :key="searchIndex + 'collapse'"
              :class="
                `search-${searchMarket.state_id} ${
                  searchMarketAreas[1].states.some(
                    (key) => key.state === searchMarket.state
                  )
                    ? 'available'
                    : 'unavailable'
                } `
              "
              @click="chooseSearchResult($event)"
            >
              {{ searchMarket.state }}
            </div>
          </div>
          <div v-if="searchMarketAreas[0].metros.length != 0" class="available">
            Metro Areas:
            <div
              v-for="(searchMarket, searchIndex) in searchMarketAreas[0].metros"
              :key="searchIndex + 'collapse'"
              :class="
                `search-${searchMarket.metro_id} ${
                  searchMarketAreas[1].metros.some(
                    (key) => key.CBSA_Title === searchMarket.CBSA_Title
                  )
                    ? 'available'
                    : 'unavailable'
                } `
              "
              @click="chooseSearchResult($event)"
            >
              {{ searchMarket.CBSA_Title }}
            </div>
          </div>
          <div
            v-if="searchMarketAreas[0].counties.length != 0"
            class="available"
          >
            Counties:
            <div
              v-for="(searchMarket, searchIndex) in searchMarketAreas[0]
                .counties"
              :key="searchIndex + 'collapse'"
              :class="
                `search-${searchMarket.county_id} ${
                  searchMarketAreas[1].counties.some(
                    (key) => key.county === searchMarket.county
                  )
                    ? 'available'
                    : 'unavailable'
                } `
              "
              @click="chooseSearchResult($event)"
            >
              {{ searchMarket.county }}
            </div>
          </div>
          <div v-if="searchMarketAreas[0].zips.length != 0" class="available">
            Zips:
            <div
              v-for="(searchMarket, searchIndex) in searchMarketAreas[0].zips"
              :key="searchIndex + 'collapse'"
              :class="
                `search-${searchMarket.zip} ${
                  searchMarketAreas[1].zips.some(
                    (key) => key.zip === searchMarket.zip
                  )
                    ? 'available'
                    : 'unavailable'
                } `
              "
            >
              <input
                aria-label="checkbox"
                @change="nextTickInput"
                type="checkbox"
                :id="'checkbox' + searchIndex"
                :value="searchMarket.zip"
                v-model="checkedBoxes"
              />

              {{ searchMarket.zip }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </md-tab>
</template>

<script>
import SidebarSearch from './SidebarSearch';
import axios from 'axios';
// import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import {PulseLoader} from '@/components';
import Vue from 'vue';
import MarketAreaTabTable from './MarketAreaTabTable';

export default {
  name: 'market-area-tab',
  props: {},
  components: {
    SidebarSearch,
    PulseLoader,
  },
  data() {
    return {
      search: 'autofill text area names...',
      markets: {},
      availableMarkets: [],
      checkedBoxes: [],
      loaded: false,
      componentKey: 0,
    };
  },
  methods: {
    nextTickInput: function() {
      this.$nextTick(() => {
        this.chooseSearchResultZips(this.checkedBoxes);
      });
    },
    removeSpaces: function(name) {
      return name.replace(/\s/g, '').replace(/,/g, ' ');
    },
    getData: function(name) {
      if (name) {
        return name.split('[')[1].split(']')[0];
      }
    },
    getName: function(name) {
      if (name) {
        return name.split('[')[0];
      }
    },
    chooseSearchResultZips: function(zips) {
      this.$store.commit('F_SET_MARKET_AREA', `${zips} [zips]`);
    },
    chooseSearchResult: function(event) {
      const id = event.target.className.split(' ')[0].split('-')[1];
      const title = this.getName(event.target.innerText);

      this.$store.commit('F_SET_MARKET_AREA', `${title} [${id}]`);
    },
    getMarkets: async function() {
      //availableMarkets
      await axios
        .get(process.env.VUE_APP_API_BASE_URL + '/info/areas', {
          params: {
            type: 'company',
            industry: this.getData(this.industry),
          },
        })
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/areas" <br>`
            );
            throw new Error(
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode
            );
          }
          const { states } = res.data.data;
          states.forEach((market) => {
            this.availableMarkets.push(market.state);
          });
        });

      await axios
        .get(process.env.VUE_APP_API_BASE_URL + '/info/areas', {
          params: {
            type: 'company',
            industry: '0',
          },
        })
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/areas" <br>`
            );
            throw new Error(
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode
            );
          }
          const { states } = res.data.data;
          states.forEach((market) => {
            this.markets[market.state] = market.state_id;
          });
          this.loaded = true;
        });
    },
    chooseMetroArea: async function(item, event) {
      event.stopPropagation();
      this.$store.commit(
        'F_SET_MARKET_AREA',
        `${item.CBSA_Title} [${item.metro_id}]`
      );

      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + '/user/search_lists/company',
          {},
          {
            params: {
              session_id: currentSession,
              profile_id: this.profileId ? this.profileId : '0',
              type: 'company',
              industry: this.getData(this.fIndustry),
              area: item.metro_id,
              zips: '0',
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/search_lists/company" <br>`
            );
            throw new Error(
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode
            );
          }
          const { id } = res.data;
          this.$store.commit('F_SET_PROFILE_ID', id);
        });
    },

    chooseCounty: async function(item, event) {
      event.stopPropagation();
      this.$store.commit(
        'F_SET_MARKET_AREA',
        `${item.county} [${item.county_id}]`
      );

      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + '/user/search_lists/company',
          {},
          {
            params: {
              session_id: currentSession,
              profile_id: this.profileId ? this.profileId : '0',
              industry: this.getData(this.fIndustry),
              type: 'company',
              area: item.county_id,
              zips: '0',
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/search_lists/company" <br>`
            );
            throw new Error(
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode
            );
          }
          const { id } = res.data;
          this.$store.commit('F_SET_PROFILE_ID', id);
        });
    },
    chooseZips: async function(item, event) {
      event.stopPropagation();

      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + '/user/search_lists/company',
          {},
          {
            params: {
              session_id: currentSession,
              profile_id: this.profileId ? this.profileId : '0',
              industry: this.getData(this.fIndustry),
              type: 'company',
              zips: item,
              area: 0,
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/search_lists/company" <br>`
            );
            throw new Error(
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode
            );
          }
          const { id } = res.data;
          this.$store.commit('F_SET_PROFILE_ID', id);
          this.$store.commit('F_SET_MARKET_AREA', `${item} [zips]`);
        });
    },
    chooseMarket: async function(event) {
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      let query = event.target.className;
      if (!query) {
        return;
      }

      let title = query.split(' ')[0];
      let id = this.getData(query);
      let currentDiv = document.getElementsByClassName(`${title} [${id}]`)[0];
      let availableAreas = [];
      let areas = {};

      this.$store.commit('F_SET_MARKET_AREA', `${title} [${id}]`);

      // Show loading bar
      let loadingDiv = document.createElement('div');
      let loadingMount = document.createElement('div');
      loadingDiv.setAttribute('class', 'available');
      loadingDiv.appendChild(loadingMount);
      currentDiv.appendChild(loadingDiv);
      const pulseLoader = Vue.extend(PulseLoader);
      const pulseLoaderToMount = new pulseLoader({
        propsData: {
          color: 'blue',
          loading: true,
        },
      }).$mount(loadingMount);

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + '/user/search_lists/company',
          {},
          {
            params: {
              session_id: currentSession,
              profile_id: this.profileId ? this.profileId : '0',
              industry: this.getData(this.fIndustry),
              type: 'company',
              zips: '0',
              area: parseInt(id),
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/search_lists/company" <br>`
            );
            throw new Error(
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode
            );
          }
          const { id } = res.data;
          this.$store.commit('F_SET_PROFILE_ID', id);
        });

      //available markets
      await axios
        .get(process.env.VUE_APP_API_BASE_URL + '/info/areas', {
          params: {
            type: 'company',
            state_id: id,
            industry: this.getData(this.industry),
          },
        })
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/areas" <br>`
            );
            throw new Error(
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode
            );
          }
          availableAreas = res.data.data;
        });

      await axios
        .get(process.env.VUE_APP_API_BASE_URL + '/info/areas', {
          params: {
            type: 'company',
            state_id: id,
          },
        })
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/areas" <br>`
            );
            throw new Error(
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode
            );
          }
          areas = res.data.data;
        });

      while (currentDiv.firstChild != currentDiv.lastChild) {
        currentDiv.removeChild(currentDiv.lastChild);
      }

      if (currentDiv.classList.contains('unclicked')) {
        currentDiv.classList.remove('unclicked');
        currentDiv.classList.add('clicked');

        let flexDiv = document.createElement('div');
        flexDiv.setAttribute('style', 'display: flex;');
        currentDiv.appendChild(flexDiv);

        //Metro Areas Scrollable Table
        let tableDiv0 = document.createElement('span');
        let tableMount0 = document.createElement('span');
        tableDiv0.appendChild(tableMount0);
        flexDiv.appendChild(tableDiv0);
        const MarketAreaTable = Vue.extend(MarketAreaTabTable);
        const MarketAreaTableToMount = new MarketAreaTable({
          propsData: {
            data: areas.metros,
            availableData: availableAreas.metros,
            attribute: 'CBSA_Title',
            name: 'Metro Areas',
            onSelect: this.chooseMetroArea,
          },
        }).$mount(tableMount0);

        //Counties Scrollable Table
        let tableDiv1 = document.createElement('span');
        let tableMount1 = document.createElement('span');
        tableDiv1.appendChild(tableMount1);
        flexDiv.appendChild(tableDiv1);
        const MarketAreaTableToMount1 = new MarketAreaTable({
          propsData: {
            data: areas.counties,
            availableData: availableAreas.counties,
            attribute: 'county',
            name: 'Counties',
            onSelect: this.chooseCounty,
          },
        }).$mount(tableMount1);

        //Zips Scrollable Table
        let tableDiv2 = document.createElement('span');
        let tableMount2 = document.createElement('span');
        tableDiv2.appendChild(tableMount2);
        flexDiv.appendChild(tableDiv2);
        const MarketAreaTableToMount2 = new MarketAreaTable({
          propsData: {
            data: areas.zips,
            availableData: availableAreas.zips,
            attribute: 'zip',
            name: 'Zip codes',
            onSelect: this.chooseZips,
          },
        }).$mount(tableMount2);
      } else {
        while (currentDiv.firstChild != currentDiv.lastChild) {
          currentDiv.removeChild(currentDiv.lastChild);
        }
        currentDiv.classList.remove('clicked');
        currentDiv.classList.add('unclicked');
      }
    },
  },
  async created() {
    await this.getMarkets();
  },
  computed: {
    fIndustry() {
      return this.$store.getters.fIndustry;
    },
    searchMarketAreas() {
      return this.$store.getters.fSearchMarketAreas;
    },
    searchLoadingMarketArea() {
      return this.$store.getters.fSearchLoadingMarketArea;
    },
    profileId() {
      return this.$store.getters.fProfileId;
    },
  },
  watch: {
    industry(newValue, oldValue) {
      this.getMarkets();
      this.componentKey = newValue;
    },
  },
};
</script>
<style lang="scss">
.unavailable {
  pointer-events: none;
  opacity: 0.5;
  color: #3c4858;
  font-size: 0.9375rem;
  margin: 16px;
}
.available {
  color: #3c4858;
  font-size: 0.9375rem;
  cursor: pointer;
  margin: 16px;
}
.correct-padding {
  padding-left: 16px;
}
.available:hover {
  color: #1a7bfa;
}
</style>
